module.exports = __webpack_public_path__ + "static/eXERCICES-2-9aae781a6975ece9322af576edd0efba.png";